import _classCallCheck from "/ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import { duplicate, hash as _hash } from '../../util';
import { DataFlowNode } from './dataflow';
/**
 * A class for the sample transform nodes
 */

export var SampleTransformNode = /*#__PURE__*/function (_DataFlowNode) {
  _inherits(SampleTransformNode, _DataFlowNode);

  function SampleTransformNode(parent, transform) {
    var _this;

    _classCallCheck(this, SampleTransformNode);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SampleTransformNode).call(this, parent));
    _this.transform = transform;
    return _this;
  }

  _createClass(SampleTransformNode, [{
    key: "clone",
    value: function clone() {
      return new SampleTransformNode(null, duplicate(this.transform));
    }
  }, {
    key: "hash",
    value: function hash() {
      return "SampleTransform ".concat(_hash(this.transform));
    }
  }, {
    key: "assemble",
    value: function assemble() {
      return {
        type: 'sample',
        size: this.transform.sample
      };
    }
  }]);

  return SampleTransformNode;
}(DataFlowNode);